import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=f0235a4a&scoped=true"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"
import style0 from "./MenuManagement.vue?vue&type=style&index=0&id=f0235a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0235a4a",
  null
  
)

export default component.exports